import { ContentSection, ListText } from './content-box'
import { formatNameForDisplay } from 'lib/text-display'
import { List, ListItem, ListItemAvatar } from '@material-ui/core'
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline'
import { useAuth } from 'lib/auth'
import { useStyles } from '../styles'

export default function AdditionalInformation({ studentId }) {
  const { user } = useAuth()

  const classes = useStyles()

  return (
    <ContentSection title="Additional Information">
      <List className={classes.informationContainer}>
        <ListItem>
          <ListItemAvatar className={classes.iconWrapper}>
            <PeopleOutlineIcon className={classes.icon} />
          </ListItemAvatar>
          <ListText
            text={`Coach ${formatNameForDisplay(
              `${user.firstName} ${user.lastName}`,
            )}`}
          />
        </ListItem>
      </List>
    </ContentSection>
  )
}
